import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApplicationRemote } from "../../infrastructure/application.remote";
import { ApplicationStateService } from "./application.state.service";
import { ApplicationData } from "../../application.model";
import { map, switchMap, tap } from "rxjs/operators";
import { ApplicationOfferBundleData, ApplicationQueryResult } from "common"

@Injectable({
  providedIn: "root",
})
export class ApplicationFacade {
  constructor(
    private readonly stateService: ApplicationStateService,
    private readonly remote: ApplicationRemote,
  ) {}

  getApplication$(id: number): Observable<ApplicationData> {
    if (this.stateService.isApplicationStateLoaded(id)) {
      return this.stateService.getApplication$(id);
    }

    return this.getRequest(id).pipe(
      tap((app: ApplicationData) => {
        this.stateService.setApplication(app);
      }),
      switchMap(() => this.stateService.getApplication$(id))
    );
  }

  private getRequest(id: number) {
    return this.remote.get(id);
  }

  getApplications$(entityId: number): Observable<ApplicationData[]> {
    return this.remote
      .queryByEntity(entityId)
      .pipe(map((res: ApplicationQueryResult) => res.values));
  }

  clearApplicationCache(): void {
    this.stateService.clearState();
  }

  getAgreementReadyOfferBundle(applicationId: number): Observable<ApplicationOfferBundleData> {
    return this.remote.getAgreementReadyOfferBundle(applicationId);
  }
}